import React, { useState, useEffect } from "react"

import "./modal-fidelization.scss"

import Titulo1 from "../../../assets/images/titulo-1-modal-fidelizacion.svg"
import Titulo2 from "../../../assets/images/titulo-2-modal-fidelizacion.svg"
import ClosedModalBtn from "../../../assets/images/boton-cerrar-modal-fidelizacion.svg"

const ModalFidelization = () => {
  const [modalActive, isModalActive] = useState(false)

  useEffect(() => {
    const COUNTRIES_VIEW = ["es-CO", "es-EC"]

    let isView = COUNTRIES_VIEW.includes(process.env.LOCALE)
    if (isView) {
      let isModal = localStorage.getItem("SHOWED_MODAL_FIDELIZATION")
      isModalActive(!isModal)
    }
  }, [])

  const ClosedModal = () => {
    isModalActive(false)
    localStorage.setItem("SHOWED_MODAL_FIDELIZATION", true)
  }

  if (modalActive) {
    return (
      <div className="f-modal-fidelization-container">
        <span
          className="f-modal-fidelization-container-closed"
          onClick={() => {
            ClosedModal()
          }}
        >
          <img src={ClosedModalBtn} alt="Boton Cerrar" />
        </span>
        <div className="f-modal-fidelization-container-title">
          <div className="f-modal-fidelization-container-title-1">
            <img src={Titulo1} alt="Aprende cómo redimir tus premios en la" />
          </div>
          <div className="f-modal-fidelization-container-title-2">
            <img src={Titulo2} alt="e-store" />
          </div>
        </div>
        <div className="f-modal-fidelization-container-wrap">
          <div className="f-modal-fidelization-container-wrap-tv"></div>
          <div className="f-modal-fidelization-container-wrap-video">
            <iframe
              width="100%"
              height="100%"
              src={
                process.env.LOCALE === "es-CO"
                ? "https://www.youtube.com/embed/HKBdSJGoKDM"
                : "https://www.youtube.com/embed/UwbEd6vKUuU"
              }
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    )
  } else {
    return <></>
  }
}

export default ModalFidelization
